import { FiCheck } from 'react-icons/fi';
import { formatKES, withVat } from '../../lib/tax';

export default function PlanPicker({ packages, selectedId, onSelect }) {
  if (packages.length === 0) {
    return <p className="text-sm text-subtle">Loading plans…</p>;
  }

  return (
    <div className="grid grid-cols-1 gap-3 sm:grid-cols-2">
      {packages.map((pkg) => {
        const active = selectedId === pkg.Id;
        const { total } = withVat(pkg.Amount);

        return (
          <button
            key={pkg.Id}
            type="button"
            onClick={() => onSelect(pkg)}
            className={`flex flex-col gap-1 rounded-xl border p-4 text-left transition ${
              active
                ? 'border-brand-400 bg-brand-gradient-soft ring-2 ring-brand-300'
                : 'border-line hover:border-brand-300 dark:border-midnight-600'
            }`}
          >
            <div className="flex items-center justify-between">
              <span className="text-sm font-bold text-ink dark:text-white">{pkg.PackageName}</span>
              {active && (
                <span className="flex h-5 w-5 items-center justify-center rounded-full bg-brand-gradient text-white">
                  <FiCheck size={12} />
                </span>
              )}
            </div>
            <span className="text-lg font-extrabold text-ink dark:text-white">
              {formatKES(pkg.Amount)} <span className="text-xs font-normal text-subtle">/month</span>
            </span>
            <span className="text-xs text-subtle">{formatKES(total)} incl. VAT</span>
          </button>
        );
      })}
    </div>
  );
}
